var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/redux-form/~/lodash/_Symbol.js
// module id = 432
// module chunks = 0